export default {
  title: 'Nebula buds AI-Anruf', // "Nebula buds AI通话" 翻译为德语
  userID: 'Benutzer-ID : ', // "用户ID : "
  hurryUp: 'Warten auf Anruf von der anderen Partei', // "等待对方呼叫"
  waitingCall: 'Warten auf Anruf von der anderen Partei auf dieser Seite, bitte schließen Sie die Seite nicht zu früh.', // "在此页面等待对方拨打电话，请勿提前关闭。"
  subSwitch: 'Untertitel-Schalter', // "字幕开关"
  initWait: 'Warten auf Initialisierung', // "等待初始化"
  initSuccess: 'Initialisierung abgeschlossen, warten Sie auf den Anruf der anderen Partei. Bitte schließen Sie die Seite nicht!', // "初始化完成，等待对方呼叫。请勿关闭页面！"
  callStart: 'Anruf verbunden', // "电话接通"
  callEnd: 'Anruf beendet', // "通话结束"
  careful: 'Achtung : ', // "注意 : "
  wait: 'Anrufkomponente ist bereit, warten Sie auf den Anruf der anderen Partei', // "通话组件已准备好,等待对方拨打电话"
  langSwitch: {
    ar: 'Arabisch', // "阿拉伯语"
    da: 'Dänisch', // "丹麦语"
    de: 'Deutsch', // "德语"
    en: 'Englisch', // "英语"
    es: 'Spanisch', // "西班牙语"
    fil: 'Filipino', // "菲律宾语"
    fr: 'Französisch', // "法语"
    hi: 'Hindi', // "印地语"
    id: 'Indonesisch', // "印度尼西亚语"
    it: 'Italienisch', // "意大利语"
    ja: 'Japanisch', // "日文"
    ko: 'Koreanisch', // "韩语"
    ms: 'Malaiisch', // "马来语"
    no: 'Norwegisch', // "挪威语"
    pt: 'Portugiesisch', // "葡萄牙语"
    ru: 'Russisch', // "俄语"
    sv: 'Schwedisch', // "瑞典语"
    th: 'Thailändisch', // "泰语"
    tr: 'Türkisch', // "土耳其语"
    vi: 'Vietnamesisch', // "越南语"
    zh: 'Chinesisch' // "中文"
  }
}
